import React from 'react';
import { Notificacao } from '../services/notificacaoService';

interface Props {
  notification: Notificacao;
}

const NotificationDropdownItem: React.FC<Props> = ({ notification }) => {
  const { usuarioAutor, mensagem, criadoEm, lida } = notification;
  const authorName = usuarioAutor?.nome || usuarioAutor?.username || 'Autor';
  const avatar = usuarioAutor?.imagemUrl || '/assets/images/user.png';

  const formattedDate = new Date(criadoEm).toLocaleString('pt-BR');

  return (
    <div className="card bg-transparent-card w-100 border-0 ps-5 mb-3">
      <img
        src={avatar}
        alt={authorName}
        className="w40 position-absolute left-0 rounded-pill"
      />
      <h5 className="font-xsss text-grey-900 mb-1 mt-0 fw-700 d-block">
        {authorName}{' '}
        <span className="text-grey-400 font-xsssss fw-600 float-right mt-1 ms-2">
          {formattedDate}
        </span>
        {/* {!lida && (
          <span
            className="ms-2 badge rounded-pill bg-primary"
            aria-label="Não lida"
            style={{ fontSize: '0.5rem' }}
          >
            •
          </span>
        )} */}
      </h5>
      <h6 className="text-grey-500 fw-500 font-xssss lh-4">{mensagem}</h6>
    </div>
  );
};

export default NotificationDropdownItem;
